<template>
  <div>
    <purchaserVisitListTable ></purchaserVisitListTable>
  </div>
</template>

<script>
    import purchaserVisitListTable from './visit/purchaserVisitListTable'
    import ajax from '@/lib/ajax'
    import requestUrls from '@/lib/requestUrls'
    export default {
        components: {
            purchaserVisitListTable,
        },
        data() {
            return {
            }
        },
        methods: {
        }
    }
</script>

<style lang="less" scoped>

</style>